import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "kanbanViewActive",
  "use": "kanbanViewActive-usage",
  "viewBox": "0 0 18 20",
  "content": "<symbol viewBox=\"0 0 18 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"kanbanViewActive\">\n<path d=\"M8.25 0.4375H3.25C1.7335 0.4375 0.5 1.74862 0.5 3.35938V16.6406C0.5 18.2514 1.7335 19.5625 3.25 19.5625H8.25V0.4375ZM14.75 0.4375H9.75V19.5625H14.75C16.2665 19.5625 17.5 18.2514 17.5 16.6406V3.35938C17.5 1.74862 16.2665 0.4375 14.75 0.4375Z\" fill=\"#F2AE00\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol